import {handleActions} from 'redux-actions';
import {Map} from 'immutable';

import * as Actions from './actions';
import RecurringPayment from './model';

const updateItems = (payments, newItemId, updateFunc) => {
    return payments.update(newItemId, RecurringPayment.default, updateFunc);
};

export default handleActions(
    {
        [Actions.fetchBillPayerPaymentsSuccess.type]: (state, action) => {
            const payments = action.payload.recurringPayments;
            return state.merge(
                Map(
                    payments.reduce((object, item) => {
                        return {
                            ...object,
                            [item.recurringPaymentId]: item,
                        };
                    }, {}),
                ),
            );
        },
        [Actions.createPaymentSuccess.type]: (state, action) => {
            const payment = action.payload.newPayment;
            return updateItems(state, payment.recurringPaymentId, () => payment);
        },
        [Actions.updatePaymentSuccess.type]: (state, action) => {
            const payment = action.payload.updatedPayment;
            return updateItems(state, payment.recurringPaymentId, () => payment);
        },
        [Actions.deletePaymentSuccess.type]: (state, action) => {
            return state.delete(action.payload.oldRecurringPaymentId);
        },
    },
    Map(),
);
